<script>
export default {
    name: 'IconEgalLight',
}
</script>
<template>
    <svg class="base-icon icon-egal-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  d="M0 15.95h64v9.67H0v-9.67ZM0 39.16h64v9.672H0v-9.671Z"/></svg>
</template>
